import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';

const show = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  if (typeof value === 'boolean') return value;
  return value;
};

/**
 * Read-only view of one record. `items` is [{ label, value }].
 */
const RecordDetailsModal = ({ show: open, title, subtitle, items = [], onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      show={open}
      title={title}
      subtitle={subtitle}
      onClose={onClose}
      footer={
        <button type="button" className="ad-btn" onClick={onClose}>
          {t('common.close')}
        </button>
      }
    >
      <div className="ad-detail-grid">
        {items.map((item) => (
          <div key={item.label} className="ad-detail-item">
            <span className="ad-detail-label">{item.label}</span>
            <span className="ad-detail-value">
              {typeof item.value === 'boolean' ? (
                <span className={`ad-badge ${item.value ? 'ad-badge-success' : ''}`}>
                  {item.value ? t('common.yes') : t('common.no')}
                </span>
              ) : (
                show(item.value)
              )}
            </span>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default RecordDetailsModal;
